/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { BoardCreateModalEntryPointProps } from './BoardCreateModal.entrypoint.types.tsx';

type BoardCreateModalEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	BoardCreateModalEntryPointProps,
	{} | null
>;

export const boardCreateModalEntryPoint: EntryPoint<BoardCreateModalEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<BoardCreateModalEntryPointComponent>(
			/* webpackChunkName: "async-board-create-modal" */ './MemoizedBoardCreateModalWithContext.tsx',
		),
		getPreloadProps: () => ({}),
	});
